/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetPublishStatusSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetPublishStatusRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetPublishStatusSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetPublishStatusSecurity$outboundSchema: z.ZodMiniType<
  GetPublishStatusSecurity$Outbound,
  GetPublishStatusSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getPublishStatusSecurityToJSON(
  getPublishStatusSecurity: GetPublishStatusSecurity,
): string {
  return JSON.stringify(
    GetPublishStatusSecurity$outboundSchema.parse(getPublishStatusSecurity),
  );
}

/** @internal */
export type GetPublishStatusRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetPublishStatusRequest$outboundSchema: z.ZodMiniType<
  GetPublishStatusRequest$Outbound,
  GetPublishStatusRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getPublishStatusRequestToJSON(
  getPublishStatusRequest: GetPublishStatusRequest,
): string {
  return JSON.stringify(
    GetPublishStatusRequest$outboundSchema.parse(getPublishStatusRequest),
  );
}
